import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { getSelectorAttribute, netsuiteIntegrationSelectors } from '@vy/app-selectors';
import { NetSuiteLogoIcon } from '@vy/ui-design-system';
import { type FC } from 'react';
import type { Control } from 'react-hook-form';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { NetSuiteRegisterFormValues } from '../NetsuiteRegisterFormSchema';

type NetSuiteRegistrationFormProps = {
  control: Control<NetSuiteRegisterFormValues>;
};

export const NetsuiteRegistrationForm: FC<NetSuiteRegistrationFormProps> = ({ control }) => (
  <FormContainer {...getSelectorAttribute(netsuiteIntegrationSelectors.registration.form)}>
    <LogoContainer>
      <NetSuiteLogoIcon
        style={{
          transform: 'scale(0.5)',
          transformOrigin: 'top left',
        }}
      />
    </LogoContainer>
    <Typography variant="h4">Enter the following fields to get started</Typography>
    <div data-vy={netsuiteIntegrationSelectors.registration.accountRealmInput}>
      <ControlledTextInput name="accountRealm" control={control} label="Account Realm" />
    </div>
    <div data-vy={netsuiteIntegrationSelectors.registration.certificateIdInput}>
      <ControlledTextInput name="certificateId" control={control} label="Certificate ID" />
    </div>
    <div data-vy={netsuiteIntegrationSelectors.registration.clientIdInput}>
      <ControlledTextInput name="clientId" control={control} label="Client ID" />
    </div>
  </FormContainer>
);

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

const LogoContainer = styled('div')({
  width: 132,
  height: 132,
});
